export default __webpack_public_path__ + "static/ecuador-flag-10ac2d729f81e1a1f860a8131c77068b.svg";